import { render, staticRenderFns } from "./AllInstitutionsPage.vue?vue&type=template&id=04fc8a5e&"
import script from "./AllInstitutionsPage.vue?vue&type=script&lang=js&"
export * from "./AllInstitutionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports